<template>
    <div>
        <form-wizard @on-complete="onComplete" shape="tab" stepSize="xs" color="#3BB273" title="" subtitle="" layout="vertical"
                     error-color="#E15554" v-loading="loading">
            <tab-content :before-change="validateAccount" title="Conturi promotor" icon="android">
                <account-form :data="promoter" :users="users" role="promoter" group="promoter"></account-form>
            </tab-content>
            <template slot="footer" slot-scope="props">
                <div class=wizard-footer-left>
                    <a href="/promoters" class="ml-2 btn btn-default" v-if="props.activeTabIndex == 0" >Anuleaza, m-am razgandit</a>
                    <wizard-button  v-if="props.activeTabIndex > 0"  @click.native="props.prevTab()" :style="props.fillButtonStyle">Inapoi</wizard-button>
                </div>
                <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="btn btn-default" :style="props.fillButtonStyle">Inainte</wizard-button>
                    <wizard-button v-else @click.native="props.nextTab()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{props.isLastStep ? 'Finalizeaza' : 'Inainte'}}</wizard-button>
                </div>
            </template>
        </form-wizard>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard';
    import AccountForm from "./form-account";
    import {mapGetters, mapActions, mapMutations} from 'vuex'

    export default {
        name: "account-wizard",
        components: {
            AccountForm,
            FormWizard,
            TabContent,
            WizardButton
        },
        props:{
            promoter: {
                required: true,
                type: Object
            },
            users: {
                required: true,
                type: Array
            },
        },
        data(){
            return {
                loading: false,
                errorMsg: null,
            }
        },
        computed:{
            ...mapGetters({
                promoterValidated: 'promoter/promoterValidated',
                promoterAccountValidated: 'promoter/promoterAccountValidated',
            })
        },
        methods: {
            ...mapMutations({
                setValidatePromoter: 'promoter/setValidatePromoter',
                setValidatePromoterAccount: 'promoter/setValidatePromoterAccount'
            }),
            ...mapActions({
                saveAccount: 'saveAccount',
                assignPromoter: 'promoter/assignPromoter',
            }),
            onComplete: function(){
                this.$notify({ type:'success', title: 'Creare promotor', message: 'Promotorul a fost creat cu succes'});
                setTimeout(function() {
                    window.location.href = '/promoters'
                },1000);
            },
            setLoading: function(value) {
                this.loading = value
            },
            validateAccount:function()
            {
                this.loading = true;
                return new Promise((resolve, reject) => {
                    this.setValidatePromoterAccount(true);
                    setTimeout(() => {
                        if (this.promoterAccountValidated) {
                            this.saveAccount(this.promoter.accounts[0]).then(response => {
                                if(!response.id) {
                                    console.log(response);
                                    this.$notify({type: 'error', title: 'Creare cont promotor', message: response.message});
                                    reject(false);
                                }else{
                                    this.assignPromoter({
                                        promoter_id : this.promoter.id,
                                        user_id : response.id,
                                        role : 'promoter',
                                        group:'promoter'
                                    }).then(result => {
                                        console.log(result);
                                        this.$notify({ type:'success', title: 'Creare cont promotor', message: 'Datele promotorului au fost salvate cu succes!' });
                                        // resolve(true);
                                    })
                                }
                            }, error => {
                                if(error.response.status === 422){
                                    this.$notify({ type:'error', title: 'Creare cont promotor', message: error.response.data.errors });
                                }
                                reject(false);
                            });
                            this.loading = false;
                        } else {
                            this.$notify({ type: 'error', title: 'Creare promotor', message: 'O eroare a aparut la crearea promotorului' });
                            this.loading = false;
                            reject(false);
                        }
                    }, 1000)
                })

            },
        }
    }
</script>

<style>
    .wizard-tab-content{
        padding-top:0 !important;
    }
    .wizard-nav-pills{
        width: 260px !important;
    }
    .wizard-nav-pills li{
        flex: none !important;
        flex-grow: 0 !important;
    }
    .tab_shape{
        display:none !important;
    }
    .wizard-btn{
        padding: 0.5rem 1.3rem !important;
        font-weight: 600 !important;
        font-size: 1.2rem !important;
        line-height: 1.4rem !important;
    }
    .stepTitle {
        border: 1px solid transparent !important;
        margin-bottom: 2px !important;
        padding: 0.75rem 1.25rem !important;
        background-color: #fff !important;
        width:100%;
    }
    .stepTitle.active{
        background-color: #3BB273 !important;
        font-weight: 700 !important;
        color:#fff !important;
    }
    .wizard-header{display:none;}
    .wizard-card-footer{margin-left:220px;}
</style>
